import React, { useState } from 'react';
import { motion } from 'framer-motion';

const API = (process.env.REACT_APP_BACKEND_URL || '').replace(/\/+$/, '');

const EmailCapture = () => {
  const [email, setEmail] = useState('');
  const [submitted, setSubmitted] = useState(false);
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!email.trim() || !email.includes('@')) return;
    setLoading(true);
    setError('');
    try {
      const res = await fetch(`${API}/api/subscribe`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ email: email.trim() })
      });
      if (res.ok) {
        setSubmitted(true);
        setEmail('');
      } else {
        const data = await res.json();
        setError(data.detail || 'Something went wrong.');
      }
    } catch {
      setError('Connection failed. Try again.');
    }
    setLoading(false);
  };

  return (
    <section 
      id="email-capture" 
      data-testid="email-capture-section"
      className="py-24 px-6 bg-gradient-to-b from-[#080C10] to-[#0a0e12]"
    >
      <motion.div
        initial={{ opacity: 0, y: 30 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true }}
        transition={{ duration: 0.8 }}
        className="max-w-xl mx-auto text-center"
      >
        <h2 className="font-['Cormorant_Garamond'] text-3xl sm:text-4xl font-bold text-[#C9A84C] mb-4">
          THE WATER ALWAYS REMEMBERS.
        </h2>
        <p className="font-['Cormorant_Garamond'] text-xl text-[#E8E0D0]/80 italic mb-8">
          DO YOU WANT TO KNOW WHAT IT KNOWS?
        </p>

        {submitted ? (
          <motion.div
            initial={{ opacity: 0, scale: 0.95 }}
            animate={{ opacity: 1, scale: 1 }}
            className="bg-[#111820] border border-[#C9A84C]/20 rounded-lg p-6"
            data-testid="email-success"
          >
            <p className="font-['Outfit'] text-[#C9A84C]">
              The water remembers you now.
            </p>
          </motion.div>
        ) : (
          <form onSubmit={handleSubmit} className="space-y-4" data-testid="email-form">
            <input
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              placeholder="Enter your email"
              className="input-gold w-full py-4 px-6 rounded font-['Outfit'] text-base"
              data-testid="email-input"
              required
            />
            {error && <p className="font-['Outfit'] text-[#8B1A1A] text-xs" data-testid="email-error">{error}</p>}
            <motion.button
              whileHover={{ scale: 1.02 }}
              whileTap={{ scale: 0.98 }}
              type="submit"
              disabled={loading}
              className="w-full bg-[#C9A84C] text-[#080C10] py-4 px-8 rounded font-['Outfit'] font-semibold tracking-wider hover:bg-[#d4b55d] transition-colors disabled:opacity-60"
              data-testid="email-submit"
            >
              {loading ? 'ENTERING...' : 'ENTER THE WATER'}
            </motion.button>
          </form>
        )}

        <p className="font-['Outfit'] text-[#E8E0D0]/40 text-xs mt-6">
          No spam. Just the story. Updates on new drops, behind-the-scenes, and universe expansions.
        </p>
      </motion.div>
    </section>
  );
};

export default EmailCapture;
